import ChurchLeaders from '../components/TeamPage/ChurchLeaders';

const TeamPage = () => {
    return (
        <>
            <ChurchLeaders/>
        </>
    );
}

export default TeamPage;